import { BlendEquationSeparate } from "../../../../RenderEngine/RenderEnum/BlendEquationSeparate";
import { BlendFactor } from "../../../../RenderEngine/RenderEnum/BlendFactor";
import { CompareFunction } from "../../../../RenderEngine/RenderEnum/CompareFunction";
import { CullMode } from "../../../../RenderEngine/RenderEnum/CullMode";
import { StencilOperation } from "../../../../RenderEngine/RenderEnum/StencilOperation";
import { RenderState } from "../../../RenderModuleData/Design/RenderState";
export class GLRenderState {
    constructor(engine) {
        this._engine = engine;
        this._gl = this._engine.gl;
    }
    _initState() {
        this.setDepthFunc(CompareFunction.Less);
        this.setBlendEquationSeparate(BlendEquationSeparate.ADD, BlendEquationSeparate.ADD);
        this._blendEquation = BlendEquationSeparate.ADD;
        this._sFactor = BlendFactor.One;
        this._dFactor = BlendFactor.Zero;
        this._sFactorAlpha = BlendFactor.One;
        this._dFactorAlpha = BlendFactor.One;
    }
    _getBlendFactor(factor) {
        const gl = this._gl;
        switch (factor) {
            case BlendFactor.Zero:
                return gl.ZERO;
            case BlendFactor.One:
                return gl.ONE;
            case BlendFactor.SourceColor:
                return gl.SRC_COLOR;
            case BlendFactor.OneMinusSourceColor:
                return gl.ONE_MINUS_SRC_COLOR;
            case BlendFactor.DestinationColor:
                return gl.DST_COLOR;
            case BlendFactor.OneMinusDestinationColor:
                return gl.ONE_MINUS_DST_COLOR;
            case BlendFactor.SourceAlpha:
                return gl.SRC_ALPHA;
            case BlendFactor.OneMinusSourceAlpha:
                return gl.ONE_MINUS_SRC_ALPHA;
            case BlendFactor.DestinationAlpha:
                return gl.DST_ALPHA;
            case BlendFactor.OneMinusDestinationAlpha:
                return gl.ONE_MINUS_DST_ALPHA;
            case BlendFactor.SourceAlphaSaturate:
                return gl.SRC_ALPHA_SATURATE;
            case BlendFactor.BlendColor:
                return gl.CONSTANT_COLOR;
            case BlendFactor.OneMinusBlendColor:
                return gl.ONE_MINUS_CONSTANT_COLOR;
        }
    }
    _getBlendOperation(factor) {
        const gl = this._gl;
        switch (factor) {
            case BlendEquationSeparate.ADD:
                return gl.FUNC_ADD;
            case BlendEquationSeparate.SUBTRACT:
                return gl.FUNC_SUBTRACT;
            case BlendEquationSeparate.REVERSE_SUBTRACT:
                return gl.FUNC_REVERSE_SUBTRACT;
            default:
                throw "Unknow type";
        }
    }
    _getGLCompareFunction(compareFunction) {
        const gl = this._gl;
        switch (compareFunction) {
            case CompareFunction.Never:
                return gl.NEVER;
            case CompareFunction.Less:
                return gl.LESS;
            case CompareFunction.Equal:
                return gl.EQUAL;
            case CompareFunction.LessEqual:
                return gl.LEQUAL;
            case CompareFunction.Greater:
                return gl.GREATER;
            case CompareFunction.NotEqual:
                return gl.NOTEQUAL;
            case CompareFunction.GreaterEqual:
                return gl.GEQUAL;
            case CompareFunction.Always:
                return gl.ALWAYS;
            default:
                return gl.LEQUAL;
        }
    }
    _getGLStencilOperation(compareFunction) {
        const gl = this._gl;
        switch (compareFunction) {
            case StencilOperation.Keep:
                return gl.KEEP;
            case StencilOperation.Zero:
                return gl.ZERO;
            case StencilOperation.Replace:
                return gl.REPLACE;
            case StencilOperation.IncrementSaturate:
                return gl.INCR;
            case StencilOperation.DecrementSaturate:
                return gl.DECR;
            case StencilOperation.Invert:
                return gl.INVERT;
            case StencilOperation.IncrementWrap:
                return gl.INCR_WRAP;
            case StencilOperation.DecrementWrap:
                return gl.DECR_WRAP;
        }
    }
    _getGLFrontfaceFactor(cullmode) {
        if (cullmode == CullMode.Front)
            return this._gl.CCW;
        else
            return this._gl.CW;
    }
    setDepthTest(value) {
        value !== this._depthTest && (this._depthTest = value, value ? this._gl.enable(this._gl.DEPTH_TEST) : this._gl.disable(this._gl.DEPTH_TEST));
    }
    setDepthMask(value) {
        value !== this._depthMask && (this._depthMask = value, this._gl.depthMask(value));
    }
    setDepthFunc(value) {
        value !== this._depthFunc && (this._depthFunc = value, this._gl.depthFunc(this._getGLCompareFunction(value)));
    }
    setStencilTest(value) {
        value !== this._stencilTest && (this._stencilTest = value, value ? this._gl.enable(this._gl.STENCIL_TEST) : this._gl.disable(this._gl.STENCIL_TEST));
    }
    setStencilWrite(value) {
        this._stencilWrite = value;
    }
    setStencilWriteMask(mask) {
        mask = this._stencilWrite ? mask : 0x00;
        if (mask !== this._stencilWriteMask) {
            this._stencilWriteMask = mask;
            this._gl.stencilMask(mask);
        }
    }
    setStencilFunc(fun, ref, mask) {
        if (fun != this._stencilFunc || ref != this._stencilRef || mask != this._stencilReadMask) {
            this._stencilFunc = fun;
            this._stencilRef = ref;
            this._stencilReadMask = mask;
            this._gl.stencilFunc(this._getGLCompareFunction(fun), ref, mask);
        }
    }
    setStencilOp(fail, zfail, zpass) {
        if (this._stencilOp_fail != fail || this._stencilOp_zfail != zfail || this._stencilOp_zpass != zpass) {
            this._stencilOp_fail = fail;
            this._stencilOp_zfail = zfail;
            this._stencilOp_zpass = zpass;
            this._gl.stencilOp(this._getGLStencilOperation(fail), this._getGLStencilOperation(zfail), this._getGLStencilOperation(zpass));
        }
    }
    setDepthBias(value) {
        if (value !== this._depthBias) {
            this._depthBias = value;
            value ? this._gl.enable(this._gl.POLYGON_OFFSET_FILL) : this._gl.disable(this._gl.POLYGON_OFFSET_FILL);
        }
    }
    setDepthBiasFactor(constantFactor, slopeFactor, clamp = 0.0) {
        if (constantFactor !== this._depthBiasConstant || slopeFactor !== this._depthBiasSlope || clamp !== this._depthBiasClamp) {
            this._depthBiasConstant = constantFactor;
            this._depthBiasSlope = slopeFactor;
            this._depthBiasClamp = clamp;
            this._gl.polygonOffset(constantFactor, slopeFactor);
        }
    }
    setBlend(value) {
        value !== this._blend && (this._blend = value, value ? this._gl.enable(this._gl.BLEND) : this._gl.disable(this._gl.BLEND));
    }
    setBlendEquation(blendEquation) {
        if (blendEquation !== this._blendEquation) {
            this._blendEquation = blendEquation;
            this._blendEquationRGB = this._blendEquationAlpha = null;
            this._gl.blendEquation(this._getBlendOperation(blendEquation));
        }
    }
    setBlendEquationSeparate(blendEquationRGB, blendEquationAlpha) {
        if (blendEquationRGB !== this._blendEquationRGB || blendEquationAlpha !== this._blendEquationAlpha) {
            this._blendEquationRGB = blendEquationRGB;
            this._blendEquationAlpha = blendEquationAlpha;
            this._blendEquation = null;
            this._gl.blendEquationSeparate(this._getBlendOperation(blendEquationRGB), this._getBlendOperation(blendEquationAlpha));
        }
    }
    setBlendFunc(sFactor, dFactor, force = false) {
        if (force || sFactor !== this._sFactor || dFactor !== this._dFactor) {
            this._sFactor = sFactor;
            this._dFactor = dFactor;
            this._sFactorRGB = null;
            this._dFactorRGB = null;
            this._sFactorAlpha = null;
            this._dFactorAlpha = null;
            this._gl.blendFunc(this._getBlendFactor(sFactor), this._getBlendFactor(dFactor));
        }
    }
    setBlendFuncSeperate(srcRGB, dstRGB, srcAlpha, dstAlpha) {
        if (srcRGB !== this._sFactorRGB || dstRGB !== this._dFactorRGB || srcAlpha !== this._sFactorAlpha || dstAlpha !== this._dFactorAlpha) {
            this._sFactorRGB = srcRGB;
            this._dFactorRGB = dstRGB;
            this._sFactorAlpha = srcAlpha;
            this._dFactorAlpha = dstAlpha;
            this._sFactor = null;
            this._dFactor = null;
            this._gl.blendFuncSeparate(this._getBlendFactor(srcRGB), this._getBlendFactor(dstRGB), this._getBlendFactor(srcAlpha), this._getBlendFactor(dstAlpha));
        }
    }
    setCullFace(value) {
        value !== this._cullFace && (this._cullFace = value, value ? this._gl.enable(this._gl.CULL_FACE) : this._gl.disable(this._gl.CULL_FACE));
    }
    setFrontFace(value) {
        value !== this._frontFace && (this._frontFace = value, this._gl.frontFace(this._getGLFrontfaceFactor(value)));
    }
    clearRenderStateCache() {
        this.renderStateCache = null;
        this.isTargetCache = null;
        this.invertFrontCache = null;
    }
    setRenderState(renderState, isTarget, invertFront) {
        if (this.isTargetCache == isTarget && this.invertFrontCache == invertFront && this.renderStateCache === renderState.hash) {
            return;
        }
        let depthWrite = renderState.depthWrite;
        this.setDepthMask(depthWrite);
        let depthTest = renderState.depthTest;
        if (depthTest == RenderState.DEPTHTEST_OFF)
            this.setDepthTest(false);
        else {
            this.setDepthTest(true);
            this.setDepthFunc(depthTest);
        }
        let stencilWrite = renderState.stencilWrite;
        this.setStencilWrite(stencilWrite);
        let stencilWriteMask = renderState.stencilWriteMask;
        this.setStencilWriteMask(stencilWriteMask);
        let stencilOp = renderState.stencilOp;
        this.setStencilOp(stencilOp.x, stencilOp.y, stencilOp.z);
        let stencilTest = renderState.stencilTest;
        if (stencilTest == RenderState.STENCILTEST_OFF) {
            this.setStencilTest(false);
        }
        else {
            this.setStencilTest(true);
            let stencilRef = renderState.stencilRef;
            let stencilReadMask = renderState.stencilReadMask;
            this.setStencilFunc(stencilTest, stencilRef, stencilReadMask);
        }
        let depthBias = renderState.depthBias;
        this.setDepthBias(depthBias);
        if (depthBias) {
            let depthBiasConstant = renderState.depthBiasConstant;
            let depthBiasSlopeScale = renderState.depthBiasSlopeScale;
            let depthBiasClamp = renderState.depthBiasClamp;
            this.setDepthBiasFactor(depthBiasConstant, depthBiasSlopeScale, depthBiasClamp);
        }
        let blend = renderState.blend;
        switch (blend) {
            case RenderState.BLEND_DISABLE:
                this.setBlend(false);
                break;
            case RenderState.BLEND_ENABLE_ALL:
                let blendEquation = renderState.blendEquation;
                let srcBlend = renderState.srcBlend;
                let dstBlend = renderState.dstBlend;
                this.setBlend(true);
                this.setBlendEquation(blendEquation);
                this.setBlendFunc(srcBlend, dstBlend);
                break;
            case RenderState.BLEND_ENABLE_SEPERATE:
                let blendEquationRGB = renderState.blendEquationRGB;
                let blendEquationAlpha = renderState.blendEquationAlpha;
                let srcRGB = renderState.srcBlendRGB;
                let dstRGB = renderState.dstBlendRGB;
                let srcAlpha = renderState.srcBlendAlpha;
                let dstAlpha = renderState.dstBlendAlpha;
                this.setBlend(true);
                this.setBlendEquationSeparate(blendEquationRGB, blendEquationAlpha);
                this.setBlendFuncSeperate(srcRGB, dstRGB, srcAlpha, dstAlpha);
                break;
        }
        let cull = renderState.cull;
        let forntFace;
        switch (cull) {
            case RenderState.CULL_NONE:
                this.setCullFace(false);
                if (isTarget != invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                this.setFrontFace(forntFace);
                break;
            case RenderState.CULL_FRONT:
                this.setCullFace(true);
                if (isTarget == invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                this.setFrontFace(forntFace);
                break;
            case RenderState.CULL_BACK:
            default:
                this.setCullFace(true);
                if (isTarget != invertFront)
                    forntFace = CullMode.Front;
                else
                    forntFace = CullMode.Back;
                this.setFrontFace(forntFace);
                break;
        }
        this.renderStateCache = renderState.hash;
        this.isTargetCache = isTarget;
        this.invertFrontCache = invertFront;
    }
}
